<template>
  <div
    :id="`customer-order-${orderId}`"
    :class="['inbox-order-item d-flex align-items-center p-3', { 'active': isActiveInbox }]"
    @click="setSelectedOrder">
    <div class="customer-img rounded-circle flex-shrink-0 bg-dark mr-2 d-none"></div>
    <div class="customer-details overflow-hidden flex-grow-1 position-relative">
      <span v-if="isUnread" class="unread position-absolute d-inline-flex"></span>
      <h3 class="mb-0">
        <slot name="customerName"></slot>
      </h3>
      <p class="mb-0 d-none">
        <slot name="messagePreview">Lorem ipsum dolor sit amet.</slot>
      </p>
    </div>
    <div class="customer-timestamp ml-2 flex-shrink-0 align-self-start d-none">
      <slot name="dateCreated"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ['order', 'orderId'],
  computed: {
    ...mapGetters({
      selectedOrder: "conversationalCommerce/selectedOrder"
    }),
    isActiveInbox: {
      get() {
        if (this.selectedOrder) return this.selectedOrder.uuid === this.order.uuid;
      },
      set(status) {
        return status;
      }
    },
    isUnread: {
      get() {
        if (this.order) return this.order.unread > 0;
      },
      set(status) {
        return status;
      }
    }
  },
  methods: {
    async setSelectedOrder() {
      this.$store.commit("conversationalCommerce/setThread", { thread: [], isInfinite: false });
      await this.$store.commit("conversationalCommerce/setSelectedOrder", { order: this.order });
      await this.$store.dispatch("conversationalCommerce/getCustomerOrderStatus");
      this.$root.$emit("startCheckingOrderStatus");
      await this.$store.dispatch("conversationalCommerce/getCustomerCart");
      this.$store.dispatch("conversationalCommerce/getBrandThread");
    }
  }
}
</script>

<style lang="scss" scoped>
.inbox-order-item {
  cursor: pointer;
  &.active {
    box-shadow: 0px 4px 15px 5px rgba(104, 105, 123, 0.1);
    border-radius: 12px;
  }
  .customer-img {
    width: 40px;
    height: 40px;
  }
  .customer-details {
    color: #49545C;
    .unread {
      right: 10px;
      top: 10px;
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: #FF2D2D;
    }
    h3 {
      font-family: MainFontBold, sans-serif;
      font-weight: normal;
      font-size: 16px;
      word-break: break-all;
    }
    p {
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &.unread {
        font-family: MainFontBold, sans-serif;
        font-weight: normal;
      }
    }
  }
  .customer-timestamp {
    font-size: 12px;
    color: #87929D;
  }
}
</style>
